import type { FC } from 'react'
import { Box, type BoxProps } from '@dhl-ui/components'
import { useScrollInputIntoView } from '@dhl/receiver-page'

export const ScrollablePageContent: FC<BoxProps> = ({ sx, ...rest }) => {
  const scrollRef = useScrollInputIntoView()

  return (
    <Box
      ref={scrollRef}
      {...rest}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        overflowY: 'auto',
        ...sx,
      }}
    />
  )
}
